import React, { useState } from 'react';
import { Card } from '../../../components/Card/Card';
import { KeyValueTable } from '../../../components/KeyValueTable/KeyValueTable';
import { ProductForm } from './Modals/ProductForm';
import { Product } from '../../../model/product';
import { formatDateTime, present } from '../../../util/util';
import { ControlledModal } from '../../../components/Modal/ControlledModal';
import { t } from '../../../locales/translate';
import { ContractName } from './ContractName';
import { PermissionButton } from '../../../components/Button/PermissionButton';

export function ProductGeneralInfo({ product }: { product: Product }): JSX.Element {
  const [editModal, setEditModal] = useState(false);

  return (
    <div className="product-general-info__settings">
      <Card
        title={t.model.product.general}
        elevation={1}
        actions={
          // Until we decide what and how to make details editable, it's restricted to admins instead of permission 'update'.
          <PermissionButton name="edit" onClick={() => setEditModal(true)} model={product} permission="isAdmin" />
        }
      >
        <KeyValueTable
          className="ticker-settings__details"
          items={[
            {
              key: t.general.slug,
              value: product.slug,
            },
            {
              key: t.model.product.owner,
              value: (product.owningCompany && product.owningCompany.name) || 'No Owner',
            },
            {
              key: t.model.company.vendors,
              value:
                // TODO Implement loop for Vendor names
                (product.vendors &&
                  product.vendors.length > 0 &&
                  product.vendors.map((v) => (
                    <>
                      {v.name}
                      <br />
                    </>
                  ))) ||
                'No Vendors',
            },
            {
              key: t.model.contract._name,
              value: product.contractId && <ContractName id={product.contractId}></ContractName>,
            },
            {
              key: t.model.datetime.publishDate,
              value: product.publishedFrom ? formatDateTime(product.publishedFrom) : t.general.notAvailable,
            },
            {
              key: t.model.product.shippableFrom,
              value: product.shippableFrom ? formatDateTime(product.shippableFrom) : t.general.notAvailable,
            },
            {
              key: t.model.product.dhlShippableFrom,
              value: product.dhlShippingFrom ? formatDateTime(product.dhlShippingFrom) : t.general.notAvailable,
            },
            {
              key: t.model.product.publicShippableFrom,
              value: product.publicShippableFrom ? formatDateTime(product.publicShippableFrom) : t.general.notAvailable,
            },
            {
              key: `${t.model.product.costAccount} 1`,
              value: product.costAccountOne,
            },
            {
              key: `${t.model.product.costAccount} 2`,
              value: product.costAccountTwo,
            },
            {
              key: t.model.product.customsTariffNumber,
              value: product.customsTariffNumber,
            },
            {
              key: t.model.product.excludeFromFeeds,
              value: product.excludeFromFeeds ? t.general.yes : t.general.no,
            },
            {
              key: t.model.product.googleFeedCategory,
              value: product.googleFeedCategory && t.model.product.googleFeedCategories[product.googleFeedCategory],
            },
            present(product.legacyId) && {
              key: t.general.legacyId,
              value: product.legacyId,
            },
          ]}
        />
      </Card>
      <ControlledModal<Product>
        open={editModal}
        model={product}
        onClose={() => setEditModal(false)}
        title={t.actions.edit(t.model.product._name)}
        size="small"
      >
        {(controller) => <ProductForm controller={controller} />}
      </ControlledModal>
    </div>
  );
}
